import React from 'react';
import { Paper, PaperProps } from '@mui/material';

interface SectionCardProps extends Omit<PaperProps, 'elevation'> {
  padded?: boolean;
}

const SectionCard: React.FC<SectionCardProps> = ({ padded = true, sx, children, ...props }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        p: padded ? 3 : 0,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default SectionCard;

